import React from 'react';
import PropTypes from 'prop-types';

export default function AddressPredictions({ predictions, onSelect }) {
  if (!predictions.length) {
    return null;
  }

  return (
    <div aria-label="predictions" className="address-autocompletion__predictions py-3 w-100">
      {predictions.map((prediction, i) => (
        <div
          aria-label="prediction"
          className="address-autocompletion__prediction clickable py-2 px-4"
          key={i}
          type="button"
          onClick={() => onSelect(prediction)}
        >
          {prediction.description}
        </div>
      ))}
    </div>
  );
}

AddressPredictions.propTypes = {
  predictions: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
};
